// Rumbo: reglas de la «contraseña de Rumbo» (decisión de Vadik, 17-oct-2026):
// 8 caracteres o más, con letras y números. Sin exigir mayúsculas ni signos.
export const LARGO_MINIMO_CONTRASENA = 8;

export type ReglasContrasena = {
  largo: boolean;
  letras: boolean;
  numeros: boolean;
};

export function comprobarReglasContrasena(
  contrasena: string,
): ReglasContrasena {
  return {
    largo: [...contrasena].length >= LARGO_MINIMO_CONTRASENA,
    letras: /\p{L}/u.test(contrasena),
    numeros: /\p{Nd}/u.test(contrasena),
  };
}

export function cumpleReglasContrasena(contrasena: string): boolean {
  const reglas = comprobarReglasContrasena(contrasena);
  return reglas.largo && reglas.letras && reglas.numeros;
}
